import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import config from '../../config';
import defaultLogo from '../../logo.svg'; // Default logo for local usage
import './Login.css'; // Add custom CSS for better styling

const Login = ({ onLogin }) => {
  const [user, setUser] = useState({ email: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(null);
  const [logoUrl, setLogoUrl] = useState(defaultLogo); // Default logo initially
  const navigate = useNavigate();

  // Fetch logo URL from API
  useEffect(() => {
    const fetchLogo = async () => {
      try {
        const response = await axios.get(`${config.apiBaseUrl}/settings`);
        const { logo } = response.data;
        if (logo) setLogoUrl(`${config.fileBaseUrl}${logo}`);
      } catch (error) {
        console.error('Error fetching logo:', error);
      }
    };
    fetchLogo();
  }, []);

  const handleInputChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Use the login endpoint here
      const response = await axios.post(`${config.apiBaseUrl}/auth/login`, {
        email: user.email,
        password: user.password,
      });

      if (response.data.access_token) {
        const token = response.data.access_token;
        localStorage.setItem('token', token);
        onLogin();            // Notify parent component that login was successful
        navigate('/');        // Redirect to home or another protected route
      } else {
        setError('Invalid login credentials. Please try again.');
      }
    } catch (err) {
      setError('Login failed. Please check your credentials.');
    }
  };

  return (
    <div className="content-wrapper d-flex align-items-center auth px-0">
      <div className="row w-100 mx-0">
        <div className="col-lg-4 mx-auto">
          <div className="auth-form-light text-left py-5 px-4 px-sm-5 rounded shadow-lg">
            {/* Logo */}
            <div className="brand-logo mb-4 text-center">
              <img
                src={logoUrl}
                alt="AMS Logo"
                style={{ width: '150px', height: 'auto', objectFit: 'contain' }}
              />
            </div>

            {/* Welcome Message */}
           

            {/* Error Message */}
            {error && <div className="alert alert-danger text-center">{error}</div>}

            {/* Login Form */}
            <form className="pt-3" onSubmit={handleSubmit}>
              {/* Email Field */}
              <div className="form-group">
                <label htmlFor="email">
                  <i className="ti-email text-primary mr-1"></i>Email
                </label>
                <input
                  type="email"
                  className="form-control form-control-sm"
                  id="email"
                  name="email"
                  value={user.email}
                  onChange={handleInputChange}
                  placeholder="Enter your email"
                  required
                />
              </div>

              {/* Password Field */}
              <div className="form-group">
                <label htmlFor="password">
                  <i className="ti-lock text-primary mr-1"></i>Password
                </label>
                <div className="input-group">
                  <input
                    type={showPassword ? 'text' : 'password'}
                    className="form-control form-control-sm"
                    id="password"
                    name="password"
                    value={user.password}
                    onChange={handleInputChange}
                    placeholder="Enter your password"
                    required
                  />
                  <div className="input-group-append">
                    <button
                      type="button"
                      className="btn btn-outline-secondary btn-sm"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      <i className={showPassword ? 'ti-eye-off' : 'ti-eye'}></i>
                    </button>
                  </div>
                </div>
              </div>

              {/* Remember Me and Forgot Password */}
              <div className="d-flex justify-content-between align-items-center mt-3">
                <div className="form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="rememberMe"
                  />
                  <label className="form-check-label text-muted" htmlFor="rememberMe">
                    Remember me
                  </label>
                </div>
                <a href="#" className="text-primary">
                  Forgot Password?
                </a>
              </div>

              {/* Submit Button */}
              <div className="mt-4">
                <button
                  type="submit"
                  className="btn btn-primary btn-block btn-sm font-weight-medium auth-form-btn"
                >
                  <i className="ti-unlock"></i> Access
                </button>
              </div>

              {/* Signup Redirect */}
              <div className="text-center mt-4 font-weight-light">
                Don't have an account?{' '}
                <a href="#" className="text-primary">
                  Sign Up
                </a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
